
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Hypothermiaprevention() {



  const cardData =
  {
    keyword: 'Hypothermia Prevention Machine Manufacturers',
    heading: 'Pharmacle Health Care Private Limited: Hypothermia Prevention Machine Manufacturers',
    headingDescription: 'Pharmacle Health Care Private Limited is a leading Hypothermia Prevention Machine Manufacturer, offering advanced thermal management solutions to maintain optimal patient body temperature during surgical and critical care procedures. Our state-of-the-art hypothermia prevention machines are designed to deliver consistent and controlled heat, effectively preventing perioperative hypothermia and enhancing patient safety. Trusted by top hospitals and healthcare facilities across India, our machines are user-friendly, reliable, and integrate seamlessly into various clinical settings. Choose Pharmacle Health Care for superior hypothermia prevention machines that elevate the standard of care and improve clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Top Hypothermia Prevention Machine Manufacturers in India",
    "description": "Pharmacle Health Care is among India’s leading manufacturers of hypothermia prevention machines, delivering safe and advanced solutions for healthcare providers. Our devices are built to maintain normothermia during surgeries and critical care, minimizing risks for patients."
  },
  {
    "title": "Advanced Hypothermia Prevention Systems for Clinical Excellence",
    "description": "Engineered with precision thermal control, Pharmacle Health Care’s hypothermia prevention systems reduce complications caused by unintended hypothermia. Featuring smart temperature monitoring and patient-friendly interfaces, they ensure effective and consistent warming in clinical environments."
  },
  {
    "title": "Reliable Hypothermia Prevention Devices for Hospitals Across India",
    "description": "Pharmacle Health Care manufactures medical-grade hypothermia prevention devices trusted by hospitals and surgical centers nationwide. With advanced warming technology, our systems support safer surgeries, quicker post-operative recovery, and greater patient comfort."
  },
  {
    "title": "Effective Hypothermia Management Machines for Surgery & ICU",
    "description": "We design hypothermia management machines that protect patients from intraoperative and postoperative hypothermia. Pharmacle Health Care’s equipment is widely used in operating rooms, intensive care units, and emergency departments for improved patient safety."
  },
  {
    "title": "Innovative Hypothermia Prevention Solutions Backed by Research",
    "description": "At Pharmacle Health Care, innovation drives our hypothermia prevention systems. Designed with energy efficiency, intuitive controls, and precise heat distribution, our devices empower clinicians to maintain patient normothermia across diverse procedures."
  },
  {
    "title": "Comprehensive Hypothermia Prevention Equipment for Hospitals",
    "description": "Our complete product range includes warming units, disposable and reusable blankets, and real-time monitoring systems. Pharmacle Health Care ensures compliance with FDA, CE, and global safety standards, making us a dependable partner for hospital thermal management."
  },
  {
    "title": "Custom-Engineered Hypothermia Prevention Devices",
    "description": "Pharmacle Health Care specializes in custom-engineered hypothermia prevention machines tailored to neonatal care, trauma care, and general surgery. These devices combine patient-centric design with reliable temperature regulation for sensitive clinical needs."
  },
  {
    "title": "Trusted Supplier of Hypothermia Control Systems in India",
    "description": "Known for quality and innovation, Pharmacle Health Care’s hypothermia control systems are trusted by India’s leading hospitals. By lowering surgical risks and supporting patient safety, we’ve become a preferred supplier nationwide."
  },
  {
    "title": "Portable Hypothermia Prevention Machines for Mobile Care",
    "description": "Compact yet powerful, our portable hypothermia prevention machines are perfect for ambulances, field hospitals, and mobile healthcare services. Pharmacle Health Care ensures these units deliver the same precision warming as larger hospital systems."
  },
  {
    "title": "Pharmacle Health Care – Partnering in Safer Patient Care",
    "description": "From R&D to delivery, Pharmacle Health Care partners with healthcare professionals to advance hypothermia prevention technology. Built for reliability under pressure, our machines provide peace of mind and better outcomes during high-risk procedures."
  }
],

"services": [
    {
        "name": "Hypothermia Prevention Machine Manufacturers",
        "description": "Pharmacle Health Care is a leading manufacturer of hypothermia prevention machines designed to maintain a safe body temperature during medical procedures. These machines are essential in preventing hypothermia, especially in surgeries or critical care situations. Our advanced technology ensures consistent and controlled temperature regulation, improving patient safety and comfort while reducing recovery times."
    },
    {
        "name": "Hypothermia Control Equipment India",
        "description": "We provide hypothermia control equipment in India, specifically designed to manage and prevent temperature-related complications during medical treatments. Our equipment ensures that patients maintain a stable core temperature, reducing the risk of hypothermia during surgeries, recovery, and critical care. Trusted by hospitals and healthcare facilities across India, our hypothermia control solutions are vital for patient safety."
    },
    {
        "name": "Hypothermia Management System for Surgery",
        "description": "Pharmacle Health Care offers hypothermia management systems designed to regulate body temperature during surgeries. These systems provide precise temperature control to prevent hypothermia, ensuring patients remain at optimal body temperatures throughout the surgical process. Our systems are crucial in reducing surgical complications, improving patient recovery, and enhancing overall surgical outcomes."
    },
    {
        "name": "Medical Devices for Hypothermia Prevention",
        "description": "We supply medical devices for hypothermia prevention, designed to regulate patient body temperature during medical procedures. These devices are essential for preventing hypothermic conditions that can arise during surgery, trauma care, or critical care treatments. Our devices offer reliable and accurate temperature regulation, improving patient safety and comfort during medical interventions."
    },
    {
        "name": "Hospital Hypothermia Treatment Equipment",
        "description": "Pharmacle Health Care provides hospital hypothermia treatment equipment designed to prevent and manage hypothermia in patients. These systems are especially useful in emergency care, surgeries, and recovery settings, where maintaining a stable body temperature is critical. Our equipment ensures safe and efficient thermal management, promoting better patient outcomes and preventing temperature-related complications."
    },
    {
        "name": "Surgical Temperature Regulation Systems",
        "description": "Our surgical temperature regulation systems are designed to maintain a safe and stable body temperature during surgical procedures. These systems are essential in preventing hypothermia, a common risk during long or complex surgeries. Pharmacle Health Care’s surgical temperature regulation systems provide accurate and reliable temperature control, contributing to improved surgical outcomes and patient safety."
    },
    {
        "name": "Body Heat Retention Machines",
        "description": "We offer body heat retention machines designed to maintain patient warmth during medical treatments. These machines are crucial for preventing hypothermia, especially during surgery or post-operative recovery. Our heat retention machines ensure consistent warmth and prevent heat loss, promoting patient comfort and safety in critical care environments."
    },
    {
        "name": "Patient Core Warming Systems",
        "description": "Pharmacle Health Care provides patient core warming systems designed to regulate and maintain the body’s core temperature during medical procedures. These systems are essential for preventing hypothermia and improving patient recovery in surgical and critical care settings. Our patient core warming systems deliver precise thermal regulation to ensure optimal comfort and safety during medical treatments."
    }
],
"tableData": [
    ["- Hypothermia Prevention Machine Manufacturers", "- Hypothermia Control Equipment India"],
    ["- Hypothermia Management System for Surgery", "- Medical Devices for Hypothermia Prevention"],
    ["- Hospital Hypothermia Treatment Equipment", "- Surgical Temperature Regulation Systems"],
    ["- Body Heat Retention Machines", "- Patient Core Warming Systems"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Hypothermia Prevention Technology",
        "WhyChoosedescription": "As leading Hypothermia Prevention Machine Manufacturers, we offer advanced technology that ensures precise temperature regulation during medical procedures. Our machines are designed to prevent hypothermia, safeguarding patient health and improving surgical outcomes."
    },
    {
        "WhyChooseheading": "Comprehensive Hypothermia Prevention Solutions",
        "WhyChoosedescription": "We provide a range of Hypothermia Prevention Machines designed for medical facilities. Our solutions include cutting-edge temperature management systems that effectively maintain patient body temperature during surgery or recovery, ensuring patient safety at all times."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Hypothermia Prevention Machines are built to the highest quality standards for durability and long-term reliability. Each machine is rigorously tested to perform optimally in high-stakes medical environments, providing continuous support for patient care."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient comfort and safety are paramount. Our Hypothermia Prevention Machines are designed to gently regulate temperature, preventing complications such as hypothermia during surgeries, ensuring patients are always kept in a safe and comfortable condition."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Hypothermia Prevention Machines are adaptable to various healthcare settings, including hospitals, operating rooms, and recovery areas. We work closely with healthcare providers to customize solutions that meet their specific needs, ensuring optimal patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Our Hypothermia Prevention Machines can be easily integrated with existing medical systems. They are designed for smooth implementation, ensuring seamless operation without disrupting ongoing medical procedures or treatments."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services to help healthcare facilities select the right Hypothermia Prevention Machines for their needs. Our dedicated support team is available for ongoing maintenance and troubleshooting to ensure your equipment functions optimally."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of our mission. Our Hypothermia Prevention Machines are designed to deliver precise temperature control, ensuring that every patient receives the best possible care during critical medical procedures."
    }
]


















  }

  const faqData = [
    {
      question: "Who are the trusted Hypothermia Prevention Machine manufacturers?",
      answer: "Pharmacle Health Care Private Limited is a trusted manufacturer of Hypothermia Prevention Machines, providing effective solutions to maintain patient body temperature during surgeries and critical care situations."
    },
    {
      question: "What is a Hypothermia Prevention Machine?",
      answer: "A Hypothermia Prevention Machine is a medical device that helps prevent unintended drops in a patient’s body temperature during surgical procedures. It typically works by circulating warm air through specialized blankets or pads."
    },
    {
      question: "What makes Pharmacle Health Care’s machines reliable for hypothermia prevention?",
      answer: "Pharmacle’s machines are engineered for consistent temperature regulation, safety, and ease of use. Their Forced Air Warming Systems are widely used in hospitals to reduce the risk of perioperative hypothermia."
    },
    {
      question: "Are Pharmacle Health Care’s Hypothermia Prevention Machines used across India?",
      answer: "Yes, Pharmacle Health Care supplies its Hypothermia Prevention Machines to hospitals and clinics throughout India, ensuring accessibility to high-quality warming technology nationwide."
    },
    {
      question: "Does Pharmacle Health Care offer training and support for these machines?",
      answer: "Absolutely. Pharmacle Health Care provides complete training, installation, and technical support to ensure safe and effective use of its Hypothermia Prevention Machines."
    }
  ];
  
  const testimonialsData = [
    {
      text: "Pharmacle’s Hypothermia Prevention Machines have significantly improved patient safety in our surgical units. The systems are reliable and easy to manage.",
      name: "Dr. Meenakshi Iyer, Trivandrum General Hospital"
    },
    {
      text: "We rely on Pharmacle Health Care’s warming solutions for hypothermia prevention. Their machines offer precision and comfort that meet our clinical demands.",
      name: "Northern Care Multispecialty Hospital"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  

  const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Patient Warming System Manufacturers in India",
  "description": "Leading Patient Warming System Manufacturers in India providing advanced medical warming equipment and surgical heating devices. Trusted suppliers of hospital warming solutions for effective patient temperature management.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5050"
  }
};

  
 

  return (
    <div>
 <Helmet>
    <title>Hypothermia Prevention Machine Manufacturers | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore top Hypothermia Prevention Machine Manufacturers in India. Providing surgical hypothermia control equipment, core warming systems, and body heat retention machines. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Hypothermia Prevention Machine Manufacturers, Hypothermia Control Equipment India, Hypothermia Management System for Surgery, Medical Devices for Hypothermia Prevention, Hospital Hypothermia Treatment Equipment, Surgical Temperature Regulation Systems, Body Heat Retention Machines, Patient Core Warming Systems"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/50.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Hypothermiaprevention;